"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

function objToMap(obj) {
  var strMap = new Map();

  for (var _i = 0, _Object$entries = Object.entries(obj); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = (0, _slicedToArray2["default"])(_Object$entries[_i], 2),
        k = _Object$entries$_i[0],
        v = _Object$entries$_i[1];

    strMap.set(k, v);
  }

  return strMap;
}

var _default = objToMap;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wdXJlLWZ1bmN0aW9ucy9vYmotdG8tbWFwLnRzIl0sIm5hbWVzIjpbIm9ialRvTWFwIiwib2JqIiwic3RyTWFwIiwiTWFwIiwiT2JqZWN0IiwiZW50cmllcyIsImsiLCJ2Iiwic2V0Il0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7OztBQUFBLFNBQVNBLFFBQVQsQ0FBa0JDLEdBQWxCLEVBQWlEO0FBQy9DLE1BQU1DLE1BQU0sR0FBRyxJQUFJQyxHQUFKLEVBQWY7O0FBQ0EscUNBQXFCQyxNQUFNLENBQUNDLE9BQVAsQ0FBZUosR0FBZixDQUFyQixxQ0FBMEM7QUFBckM7QUFBQSxRQUFPSyxDQUFQO0FBQUEsUUFBVUMsQ0FBVjs7QUFDSEwsSUFBQUEsTUFBTSxDQUFDTSxHQUFQLENBQVdGLENBQVgsRUFBY0MsQ0FBZDtBQUNEOztBQUNELFNBQU9MLE1BQVA7QUFDRDs7ZUFFY0YsUSIsInNvdXJjZXNDb250ZW50IjpbImZ1bmN0aW9uIG9ialRvTWFwKG9iajogb2JqZWN0KTogTWFwPHN0cmluZywgYW55PiB7XG4gIGNvbnN0IHN0ck1hcCA9IG5ldyBNYXAoKTtcbiAgZm9yIChjb25zdCBbaywgdl0gb2YgT2JqZWN0LmVudHJpZXMob2JqKSkge1xuICAgIHN0ck1hcC5zZXQoaywgdik7XG4gIH1cbiAgcmV0dXJuIHN0ck1hcDtcbn1cblxuZXhwb3J0IGRlZmF1bHQgb2JqVG9NYXA7XG4iXX0=